import { IFilterOption } from "@faire/web-api--source/indigofair/data/IFilterOption";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";

import { buildFilterKey, SORT_FILTER_TYPE } from "./filterKeys";

export const getSort = (
  filterSections: ReadonlyArray<IFilterSection>
): IFilterSection | undefined => {
  return filterSections.find(
    (filterSection) =>
      filterSection.field_function === IFilterSection.FieldFunction.SORT
  );
};

export function getFilterOptions(sections: ReadonlyArray<IFilterSection>) {
  return sections.reduce<IFilterOption[]>((acc, section) => {
    if (section.options) {
      acc = acc.concat(getFilterOptionsRecursively(section.options));
    }
    return acc;
  }, []);
}

function getFilterOptionsRecursively(
  options: IFilterOption[]
): IFilterOption[] {
  let result = options;
  options.forEach((option) => {
    if (option.sub_options?.length) {
      result = result.concat(getFilterOptionsRecursively(option.sub_options));
    }
  });
  return result;
}

function getSelectedFilterKeysFromOptions(
  filterOptions: IFilterOption[],
  defaultSortKey: string | undefined = buildFilterKey(
    SORT_FILTER_TYPE,
    "featured"
  )
) {
  return [
    ...new Set(
      filterOptions
        .map((option) =>
          option.key !== defaultSortKey && option.is_selected ? option.key! : ""
        )
        .filter((filterKey) => !!filterKey)
    ),
  ];
}

export function getSelectedFilterKeys(
  filterSections: ReadonlyArray<IFilterSection>
) {
  const sortSection = getSort(filterSections);
  const defaultSortKey = sortSection?.default_option_key;
  const filterOptions = getFilterOptions(filterSections);
  return getSelectedFilterKeysFromOptions(filterOptions, defaultSortKey);
}
